import React, { Component } from 'react';
import OktaAuth from '@okta/okta-auth-js';
import { withAuth } from '@okta/okta-react';

import App from '../App';

import './style.css';

class LoginForm extends Component {
  state = {
    sessionToken: null,
    username: '',
    password: '',
    error: ''
  };
  constructor(props) {
    super(props);
    this.oktaAuth = new OktaAuth({ url: props.baseUrl });
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleUsernameChange = this.handleUsernameChange.bind(this);
    this.handlePasswordChange = this.handlePasswordChange.bind(this);
  }
  handleSubmit(e) {
    e.preventDefault();
    this.oktaAuth
      .signIn({
        username: this.state.username,
        password: this.state.password
      })
      .then(res => {
        window.localStorage.setItem('dealId', '');
        window.localStorage.setItem('section', '');
        window.localStorage.setItem('active-user-id', this.state.username);
        this.setState({
          sessionToken: res.sessionToken
        });
      })
      .catch(err => {
        this.setState({
          error: 'Sign in failed!'
        });
      });
  }
  handleUsernameChange(e) {
    this.setState({ username: e.target.value });
  }
  handlePasswordChange(e) {
    this.setState({ password: e.target.value });
  }
  render() {
    if (this.state.sessionToken) {
      this.props.auth.redirect({ sessionToken: this.state.sessionToken });
      return null;
    }
    return (
      <div className="login">
        <div className="login-form">
          <div className="login-header">
            <div className="login-logo" />
            <h1 className="login-title">Deals</h1>
          </div>
          <form onSubmit={this.handleSubmit} className="login-form-container">
            {this.state.error && (
              <div className="login-field-error">{this.state.error}</div>
            )}
            <div className="login-field">
              <div className="login-label">Username</div>
              <input
                type="text"
                className="login-input"
                value={this.state.username}
                onChange={this.handleUsernameChange}
              />
            </div>
            <div className="login-field">
              <div className="login-label">Password</div>
              <input
                type="password"
                className="login-input"
                value={this.state.password}
                onChange={this.handlePasswordChange}
              />
            </div>
            <div className="login-field">
              <div className="login-label" />
              <input
                className="login-button"
                type="submit"
                value="Login Via Okta"
              />
            </div>
          </form>
        </div>
      </div>
    );
  }
}

const LoginFormWithAuth = withAuth(LoginForm);

class Login extends Component {
  state = {
    authenticated: null
  };
  constructor(props) {
    super(props);
    this.state = { authenticated: null };
    this.checkAuthentication = this.checkAuthentication.bind(this);
    this.checkAuthentication();
  }
  async checkAuthentication() {
    const authenticated = await this.props.auth.isAuthenticated();
    if (authenticated !== this.state.authenticated) {
      this.setState({ authenticated });
    }
  }
  componentDidUpdate() {
    this.checkAuthentication();
  }
  render() {
    if (this.state.authenticated === null) return null;
    return this.state.authenticated ? (
      <App />
    ) : (
      <LoginFormWithAuth baseUrl="https://adamsstreetpartnersext.okta.com" />
    );
  }
}

export default withAuth(Login);
